import { forwardRef } from "react";

import Clickable, { ClickableProps } from ".";

import styles from "./button.module.scss";

export const TextLink = forwardRef<
    HTMLAnchorElement | HTMLButtonElement,
    ClickableProps
>(({ className, ...otherProps }, ref) => {
    return (
        <Clickable
            className={`${styles.buttonReset} ${styles.link} ${
                !!className ? className : ""
            }`}
            {...otherProps}
            ref={ref}
        />
    );
});
